const LOCAL_ACCESS_TOKEN = "access_token";
const LOCAL_REFRESH_TOKEN = "refresh_token";
const LOCAL_PROFILE = "profile";
const SESSION_CURRENT_DATE = "cd";
const LOCAL_PATH_NAME = "path_name";

export const STORAGE = {
  LOCAL_ACCESS_TOKEN,
  LOCAL_REFRESH_TOKEN,
  LOCAL_PROFILE,
  SESSION_CURRENT_DATE,
  LOCAL_PATH_NAME
};
